/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Order,
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrderDataFrame
 */
export interface OrderDataFrame {
    /**
     * 
     * @type {number}
     * @memberof OrderDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Order>}
     * @memberof OrderDataFrame
     */
    data: Array<Order>;
}

export function OrderDataFrameFromJSON(json: any): OrderDataFrame {
    return OrderDataFrameFromJSONTyped(json, false);
}

export function OrderDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(OrderFromJSON)),
    };
}

export function OrderDataFrameToJSON(value?: OrderDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(OrderToJSON)),
    };
}


